import { html, css } from 'lit'
import { TableBase } from 'shared/tables/table-base.component'
import { CRONExpressionToString as cronToString } from '../shared/cron-parser'
import { bulkActionClick } from "shared/bulkActionHelpers";
import { Assets } from "../shared/assets";


class integrationsTable extends TableBase {

    static styles = [
        TableBase.styles,
        css`

    .action svg {
      height: 27px;
      width: 27px;
      padding: 1px;
      margin-right: 10px;
    }
    .action svg path {
      transition: fill .2s;
      fill: white;
    }
    .action svg circle {
      transition: fill .2s;
      stroke: white;
    }

    .action:hover {
      color: #d6d9e0;
    }
    .action:hover svg path {
      fill: #d6d9e0
    }
    .action:hover svg circle {
      stroke: #d6d9e0
    }

   .danger {
      color: #D75762;
    }

    .c-column span{
      display: inline-flex;
    }

   .fa{
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      -webkit-font-smoothing: antialiased;
      display: inline-block;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      line-height: 1;
      cursor: pointer;
   }


    .fa-exclamation-triangle{
      margin-left: 5px;
      margin-top: 3px;
    }
    .fa-exclamation-triangle:before {
        content: "\\f071";
    }

    :host {
        display: block;
    }
    .v-table, table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed; /* This is the key line */
    }
    .v-table th, .v-table td, th, td {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /* Example: Set specific widths for columns by their order or class */
    th.bulk_action, td.bulk_action { width: 44px; min-width: 44px; max-width: 44px; }
    th.name, td.name { width: 18%; min-width: 120px; }
    th.updatedAt, td.updatedAt { width: 15%; min-width: 120px; }
    th.fileUrl, td.fileUrl { width: 18%; min-width: 120px; }
    th.status, td.status { width: 13%; min-width: 80px; }
    th.schedule, td.schedule { width: 13%; min-width: 100px; }
    th.actions, td.actions { width: 90px; min-width: 90px; max-width: 120px; text-align: right; }

    `,
    ];

    static properties = {
        allowed: {}
    };


    constructor() {
        super()

        this.route = '/integrations/:id'
        this.dataName = 'integrations'
        this.columns = [
            { key: 'bulk_action', title: '', display: 'always-left' },
            { key: 'name', title: 'Name' },
            { key: 'updatedAt', title: 'Last update' },
            { key: 'fileUrl', title: 'File URL' },
            { key: 'status', title: 'Status' },
            { key: 'schedule', title: 'Schedule' },
            { key: 'actions', title: '', display: 'always-right' },
        ]
        this.paginationEnabled = true;
        this.paginationOptions.dataName = this.dataName;
        this.searchEnabled = true

        this.bulkActionsMenu = html`
            <div class="action delete"
                data-url="${Routes.integrations_path()}"
                data-method="delete"
                @click=${bulkActionClick}
            >
            ${Assets.inlineSvg('subnavigation/delete.svg')} Delete
            </div>
        `;
    }

    cellValue(colKey, item) {
        const allowedActions = new Set(
          (this.allowed || '')
              .split(',')
              .map(x => x.toLowerCase())
        );
      
        let value = html``;

        if (colKey === 'name') {
            value = item.name
        }
        else if (colKey === 'bulk_action' && allowedActions.has('destroy')) {
            value = html`<mss-checkbox name="Location" value="${item.id}"></mss-checkbox>`
        
        } else if (colKey === 'updatedAt') {
            let dates = $.map(item.backgroundJobs, function (i) {
                if (i['completedAt']) {
                    return Date.parse(i['completedAt'])
                }
            })
            if (dates.length > 0) {
                let paredDate = new Date(Math.max(...dates));
                value = Util.formatDateTime(paredDate);
            } else {
                value = ''
            }
        } else if (colKey === 'status') {
            value = []
            if (item.backgroundJobs.length > 0) {
                let backgroundJob = item.backgroundJobs[0]
                let jobStatus = backgroundJob.status
                if (jobStatus == 'COMPLETED' && backgroundJob.hasErrors) {
                    jobStatus = 'WARNING'
                }
                value.push(html`${jobStatus}`);
                if (backgroundJob.hasErrors) {
                    value.push(html`<span class="danger fa fa-exclamation-triangle"></span>`)
                }
            }
            value
        } else if (colKey === 'fileUrl') {
            value = item.fields.find(x => x.name === 'SFTP Address')?.value || item.fields.find(x => x.name === 'FTP Address')?.value
        } else if (colKey === 'schedule') {
            value = cronToString(item.fields.find(x => x.name === 'Schedule String')?.value)
        } else if (colKey === 'mapped') {
            let data = item.fields.find(x => x.name === 'Field Map')?.value
            if (data) {
                value = '<div>'
                let parsedJson = JSON.parse(data)
                Object.entries(parsedJson).forEach(([k, v]) => {
                    value += k + ':' + v + '<br>';
                });
                value += '</div>'
            }
            value = $(value);
        } else if (colKey === 'actions') {
            value = [
                {
                    title: 'View',
                    url: Routes.integration_path(item.id),
                    httpMethod: 'get',
                    remote: false,
                    protect: 'show'
                },
                {
                    title: 'Edit',
                    url: Routes.edit_integration_path(item.id),
                    httpMethod: 'get',
                    remote: false,
                    protect: 'update'
                }, {
                    title: 'Run',
                    url: Routes.integration_run_path(item.id),
                    httpMethod: 'post',
                    remote: false,
                    protect: 'edit'
                },
                {
                    title: 'Delete',
                    url: Routes.integration_path(item.id),
                    httpMethod: 'delete',
                    remote: false,
                    confirm: `Are you sure you want to delete ${item.name || 'this record'}?`,
                    protect: 'destroy'
                },
            ]
        }
        return value
    }
}

customElements.define('integrations-table', integrationsTable)

